import React from 'react'

import styles from './styles.module.scss'

const SERVICE_ITEMS = [
  'Eligibility verification and VA documentation',
  'Scheduling directly with Arlington National Cemetery',
  'Military honors, including flag presentation and Taps',
  'Transfer of your loved one into our care, including airport coordination',
  'Transportation logistics, whether local or from out of state',
  'Dignified sheltering of caskets and urns while arrangements are finalized',
  'Guidance for family arrival, accommodations, and logistics',
  'On-site planning and day-of coordination at Arlington',
  'Coordination of clergy, speakers, and meaningful service elements',
  'Support with tributes, personal touches, and memorial details',
  'Steady communication and guidance throughout',
]

const ServiceListSection: React.FC = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.columns}>
          <div className={styles.copyColumn}>
            <h3 className={styles.heading}>What We Manage On Your Behalf:</h3>
            <ul className={styles.list}>
              {SERVICE_ITEMS.map((item) => (
                <li key={item} className={styles.listItem}>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className={styles.imageColumn}>
            <img
              src="/veteran-services/kalas-sign.png"
              alt="Kalas Funeral Home and Crematory sign"
              className={styles.image}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default ServiceListSection
